import { sendEloquaData } from './graphQlSvc';

const EloquaActions = {
    SET_ELOQUACOMPETITORLINKCAPTURE_START: 'SET_ELOQUACOMPETITORLINKCAPTURE_START',
    SET_ELOQUACOMPETITORLINKCAPTURE_SUCCESS: 'SET_ELOQUACOMPETITORLINKCAPTURE_SUCCESS',
    SET_ELOQUACOMPETITORLINKCAPTURE_FAIL: 'SET_ELOQUACOMPETITORLINKCAPTURE_FAIL',

    sendEloquaCompetitorLinkCapture: (data) => {
        const start = () => ({ type: EloquaActions.SET_ELOQUACOMPETITORLINKCAPTURE_START });
        const success = (eloquaReponseData) => {
            if (eloquaReponseData.statusCode === 200) {
                return ({
                    type: EloquaActions.SET_ELOQUACOMPETITORLINKCAPTURE_SUCCESS
                });
            }
            return ({ type: EloquaActions.SET_ELOQUACOMPETITORLINKCAPTURE_FAIL });
        };
        const fail = () => ({ type: EloquaActions.SET_ELOQUACOMPETITORLINKCAPTURE_FAIL });
        return dispatch => dispatch(
            sendEloquaData(data, start, success, fail)
        );
    }
};

export default EloquaActions;
